import React, { useEffect, useRef, useState } from "react"; //added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  channelPartnerList,
  channelPartnerStatusUpdate,
  channelPartnerApprove,
  getAssignCPList,
} from "reduxStore/action/channelPartnerAction";
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import TableListSkeleton from "component/common/TableListSkeleton";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import { channelPartnerUserType } from "utils/constants";
import usePage from "utils/usePage";
import moment from "moment";
import Select from "react-select";
import { cpCurrentMaping } from "../../reduxStore/action/channelPartnerAction";
import AllocateProperty from "../../component/common/AllocateProperty";
import apiEndPoints from "utils/apiEndPoints";
import { apiCall, errorToast, successToast } from "utils/httpClient";
import { formatAppointmentCellValue } from "utils/appointmentListStatusDisplay";
import "./ChannelPartnerListing.css";

const PAGE_SIZE_OPTIONS = [20, 50, 75, 100];

const renderCpCell = (value, toneClass = "") => {
  const text = formatAppointmentCellValue(value);
  const tone = text === "-" ? "cp-listing__empty" : toneClass;
  return (
    <span className={`cp-listing__cell ${tone}`.trim()}>{text}</span>
  );
};

const formatClosingPercentage = (value) => {
  if (!value) return "-";
  return `${Number(String(value).replace("%", "")).toFixed(2)}%`;
};

const ChannelPartner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formState, setFormState] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [isListLoading, setIsListLoading] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const initialListFetchDone = useRef(false);
  const skipStaleListResponse = useRef(false);
  const [currentCPMaping, setCurrentCPMaping] = useState([]);
  const [tlList, setTlList] = useState([]);
  const [smList, setSmList] = useState([]);
  const [isApproved, setIsApproved] = useState(false);
  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner,
  );
  const cpCurrentMapingSelector =
    useSelector((state) => state?.cpMapingData) || {};

  const permissionSelector = useSelector((state) => state.permission);
  const { isAdmin = false } = permissionSelector;

  const { response: res } = useSelector((state) => state.login);

  const [modalShow, setModalShow] = useState(false);
  const [selectedCpId, setSelectedCpId] = useState("");

  const handleAllocateClick = (cp_id) => {
    setModalShow(true); // Show the modal
    setSelectedCpId(cp_id);
  };

  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedCpId("");
  };

  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [selectedItem, setSelectedItem] = useState(null); // Store the selected item for confirmation

  // Function to handle the button click (show modal with action)
  const handleButtonClick = (item, action) => {
    setSelectedItem(item); // Set the selected item for confirmation
    setShowModal(true); // Show the modal
  };

  // Function to handle confirmation of the action
  const handleConfirm = () => {
    if (selectedItem) {
      activeDeactive(
        selectedItem._id,
        selectedItem.active_status ? true : false,
        selectedItem?.total_visit,
      ); // Call the activeDeactive function
      setShowModal(false); // Close the modal
    }
  };

  // Function to handle modal cancel
  const handleCancel = () => {
    setShowModal(false); // Close the modal without any action
  };

  const activeDeactive = async (user_id, active_status, isLead) => {
    if (isLead === 0) {
      const params = {
        user_id, // The ID of the user/channel partner
        status: 2, // Status is always 2 as per your requirement
        active_status, // Current active_status value from the item
      };

      try {
        const response = await apiCall(
          "post",
          apiEndPoints.SMCHANNELPARTNERSTATUS,
          params,
        );
        if (response?.data?.status === 200) {
          // Handle successful response (e.g., show a success message)
          successToast(response?.data?.message);
          fetchList(page, itemsPerPage, { applyFilters: true });
          setIsApproved(false);
          // Optionally, trigger a state update to reflect the changes in UI
        } else {
          errorToast(response?.data?.message);
        }
      } catch (error) {
        console.error("Error calling API:", error);
      }
    } else {
      const params = {
        user_id, // The ID of the user/channel partner
        active_status, // Current active_status value from the item
      };

      try {
        const response = await apiCall(
          "post",
          apiEndPoints.TRANSFERCHANELPARTNERSTATUS,
          params,
        );
        if (response?.data?.status === 200) {
          // Handle successful response (e.g., show a success message)
          successToast(response?.data?.message);
          fetchList(page, itemsPerPage, { applyFilters: true });
          setIsApproved(false);
          // Optionally, trigger a state update to reflect the changes in UI
        } else {
          errorToast(response?.data?.message);
        }
      } catch (error) {
        console.error("Error calling API:", error);
      }
    }
  };

  const params = new URLSearchParams(window.location.search);
  const roleId = params.get("role_id");
  const userType = params.get("user_type")
    ? params.get("user_type")
    : channelPartnerUserType.cp;

  const { create, view, edit } = usePermission({
    create: "add_channelpartner",
    view: "view_channelpartner",
    edit: "edit_channelpartner",
  });
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    cp_name: "",
    status: "",
    limit: "",
    offset: "",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const buildAdminListParams = (
    offset,
    limit,
    { applyFilters = false } = {},
  ) => {
    const params = {
      user_type: userType,
      limit,
      offset,
      role_id: roleId,
    };
    if (applyFilters) {
      if (form.start_date) params.start_date = form.start_date;
      if (form.end_date) params.end_date = form.end_date;
      const name = form.cp_name?.trim();
      if (name) params.search_by_name = name;
      if (form.status === "active") params.status = "true";
      if (form.status === "inactive") params.status = "false";
    }
    return params;
  };

  const fetchList = (
    offset = page,
    limit = itemsPerPage,
    { applyFilters = false } = {},
  ) => {
    setIsListLoading(true);
    if (isAdmin) {
      dispatch(
        channelPartnerList(buildAdminListParams(offset, limit, { applyFilters })),
      );
    } else {
      const params = {
        user_id: res?.data?._id,
        limit,
        offset,
      };
      if (applyFilters) {
        params.startdate = form.start_date;
        params.enddate = form.end_date;
        const name = form.cp_name?.trim();
        if (name) params.search_by_name = name;
        if (form.status === "active") params.status = 2;
        if (form.status === "inactive") params.status = 1;
      }
      dispatch(getAssignCPList(params));
    }
  };

  useEffect(() => {
    initialListFetchDone.current = false;
    skipStaleListResponse.current = true;
    setchannelPartnerList([]);
    fetchList(page, itemsPerPage);
    if (!isAdmin) {
      setIsApproved(false);
    }
  }, [dispatch]);

  useEffect(() => {
    if (cpCurrentMapingSelector.response) {
      const { response } = cpCurrentMapingSelector;
      if (response?.status === 200) {
        setCurrentCPMaping(
          handleListResponse([...response.data, ...response.userdata]),
        );
        const tlArrayData = response.data.map((el) => {
          return {
            main_parent_id: el.main_parent_id,
            user_name: el.stl_name[0],
          };
        });
        const tlArrayUserData = response.userdata.map((el) => {
          return {
            main_parent_id: el.parent_id,
            user_name: el.user_name,
            _id: el._id,
          };
        });
        // tlArray.push(...tlArrayUserData)

        const smArray = response.data.map((el) => {
          return {
            _id: el.parent_id,
            user_name: el.sm_name[0],
          };
        });
        const arrayUniqueTL = [
          ...new Map(
            tlArrayData.map((item) => [item["main_parent_id"], item]),
          ).values(),
        ];
        setTlList(tlArrayUserData);
        setSmList(smArray);
        setFormState({
          ...formState,
          currentCPMapingTL: arrayUniqueTL,
          currentCPMapingSM: smArray,
        });
      } else {
        setCurrentCPMaping([]);
      }
    }
  }, [cpCurrentMapingSelector]);

  useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;

    if (skipStaleListResponse.current) {
      skipStaleListResponse.current = false;
      return;
    }

    if (create && initialListFetchDone.current) {
      fetchList(page, itemsPerPage);
      if (!isAdmin) {
        setIsApproved(false);
      }
      return;
    }

    if (response?.status === 200) {
      initialListFetchDone.current = true;
      setchannelPartnerList(
        response.data?.length > 0 && handleListResponse(response?.data)
          ? response?.data
          : [],
      );
      setIsListLoading(false);
    } else if (Array.isArray(response)) {
      initialListFetchDone.current = true;
      setchannelPartnerList([]);
      setIsListLoading(false);
    } else if (!response) {
      setchannelPartnerList([]);
    } else {
      setIsListLoading(false);
    }
  }, [channelPartnerListSelector]);

  const handleSelectMultiTL = (value) => {
    setFormState({
      ...formState,
      currentCPMapingTL: value,
    });
  };
  const handleSelectMultiSM = (value) => {
    setFormState({
      ...formState,
      currentCPMapingSM: value,
    });
  };

  const handleUserStatus = (data) => {
    dispatch(channelPartnerStatusUpdate(data));
  };

  const filterDetail = () => {
    if (!handleValid()) {
      setIsListLoading(true);
      setPage(0);
      if (isAdmin) {
        dispatch(
          channelPartnerList(
            buildAdminListParams(0, itemsPerPage, { applyFilters: true }),
          ),
        );
      } else {
        dispatch(
          getAssignCPList({
            user_id: res?.data?._id,
            limit: itemsPerPage,
            offset: 0,
            startdate: form.start_date,
            enddate: form.end_date,
            search_by_name: form.cp_name?.trim() || "",
            status:
              form.status === "active"
                ? 2
                : form.status === "inactive"
                  ? 1
                  : undefined,
          }),
        );
      }
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      cp_name: "",
      status: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    if (isAdmin) {
      fetchList(0, itemsPerPage);
    } else {
      dispatch(
        getAssignCPList({
          user_id: res?.data?._id,
          limit: itemsPerPage,
          offset: 0,
        }),
      );
    }
    setPage(0);
  };

  const handlePageSizeChange = (e) => {
    const nextSize = Number(e.target.value);
    setItemsPerPage(nextSize);
    setPage(0);
    fetchList(0, nextSize, { applyFilters: true });
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    fetchList(newOffset, itemsPerPage, { applyFilters: true });
  };

  const deactiveCps = () => {
    setIsApproved(true);
    dispatch(
      getAssignCPList({
        user_id: res?.data?._id,
        status: 1,
      }),
    );
  };

  const backToCpList = () => {
    setIsApproved(false);
    fetchList(page, itemsPerPage);
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Channel Parnter Listing",
      metaDescription: "Channel partner listing",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleApprove = (itemId) => {
    const data = { cp_id: itemId, approved: true }; // Create the object to send
    dispatch(channelPartnerApprove(data)); // Pass data to the action
    setModalOpen(false); // Close modal after approval
  };

  const openApprovalModal = (itemId) => {
    setSelectedItemId(itemId);
    setModalOpen(true); // Open modal when Approve button is clicked
  };

  return (
    <div className="page-body justo-cp-page">
      <div
        className="modal fade"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabe2">
                Allocation
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlSelect9">
                    {strings.sourcingTL}
                  </label>
                  <Select
                    isSearchable
                    isMulti
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={currentCPMaping || []}
                    getOptionLabel={(option) => option.user_name}
                    getOptionValue={(option) => option._id}
                    name="currentCPMapingTL"
                    value={formState.currentCPMapingTL}
                    onChange={handleSelectMultiTL}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlSelect9">
                    {strings.sourcingManager}
                  </label>
                  <Select
                    isSearchable
                    isMulti
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={currentCPMaping || []}
                    getOptionLabel={(option) => option.user_name}
                    getOptionValue={(option) => option._id}
                    name="currentCPMapingSM"
                    value={formState.currentCPMapingSM}
                    onChange={handleSelectMultiSM}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Breadcrumb
        title={strings.channelPartner}
        titleactive={strings.channelPartnerListing}
      />

      <div className="container-fluid justo-cp">
        <div className="justo-cp__card">
          <div className="justo-cp__top">
            <div className="justo-cp__title-block">
              <h1 className="justo-cp__title">
                {isApproved
                  ? strings.approveNewCp
                  : strings.listOfChannelPartner}
              </h1>
              <p className="justo-cp__subtitle">
                {strings.channelPartnerListSubtitle}
              </p>
            </div>
            <div className="justo-cp__top-actions">
              {isApproved ? (
                <button
                  type="button"
                  className="justo-cp__btn justo-cp__btn--ghost"
                  onClick={() => backToCpList()}
                >
                  {strings.back}
                </button>
              ) : (
                <>
                  {create ? (
                    <button
                      type="button"
                      className="justo-cp__btn justo-cp__btn--solid"
                      onClick={() => navigatpage("/add_channel_partner")}
                    >
                      {strings.addNewCP}
                    </button>
                  ) : null}
                  {!isAdmin ? (
                    <>
                      <button
                        type="button"
                        className="justo-cp__btn justo-cp__btn--outline"
                        onClick={() => deactiveCps()}
                      >
                        {strings.approveNewCp}
                      </button>
                      <button
                        type="button"
                        className="justo-cp__btn justo-cp__btn--ghost"
                        onClick={() => navigatpage("/allocateCpToSM")}
                      >
                        {strings.allocateCpToSm}
                      </button>
                    </>
                  ) : null}
                </>
              )}
            </div>
          </div>

          <form
            className="justo-cp__filters"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="justo-cp__filters-grid justo-cp__filters-grid--4">
              <label className="justo-cp__field">
                <span className="justo-cp__label">{strings.searchByName}</span>
                <input
                  className="form-control justo-cp__input"
                  type="text"
                  name="cp_name"
                  value={form.cp_name}
                  onChange={handleInputField}
                  placeholder={strings.searchName}
                  autoComplete="off"
                />
              </label>
              <label className="justo-cp__field">
                <span className="justo-cp__label">{strings.status}</span>
                <select
                  className="form-control justo-cp__input"
                  name="status"
                  value={form.status}
                  onChange={handleInputField}
                >
                  <option value="">All</option>
                  <option value="active">{strings.active}</option>
                  <option value="inactive">{strings.inactive}</option>
                </select>
              </label>
              <label className="justo-cp__field">
                <span className="justo-cp__label">{strings.startDate}</span>
                <input
                  className="form-control justo-cp__input"
                  type="date"
                  name="start_date"
                  value={form.start_date}
                  onChange={handleInputField}
                />
              </label>
              <label className="justo-cp__field">
                <span className="justo-cp__label">{strings.endDate}</span>
                <input
                  className="form-control justo-cp__input"
                  type="date"
                  name="end_date"
                  value={form.end_date}
                  onChange={handleInputField}
                  min={form.start_date}
                  disabled={endDateDisable}
                />
                {formVaild.end_date ? (
                  <span className="justo-cp__error">{formVaild.end_date}</span>
                ) : null}
              </label>
              <div className="justo-cp__filter-actions">
                <button
                  className="justo-cp__btn justo-cp__btn--solid"
                  type="button"
                  onClick={filterDetail}
                >
                  {strings.search}
                </button>
                <button
                  className="justo-cp__btn justo-cp__btn--ghost"
                  type="button"
                  onClick={filterReset}
                >
                  {strings.reset}
                </button>
              </div>
            </div>
          </form>

          <div className="justo-cp__toolbar">
            <div className="justo-cp__page-size">
              <label htmlFor="cp-page-size" className="justo-cp__page-size-label">
                {strings.rowsPerPage}
              </label>
              <select
                id="cp-page-size"
                className="justo-cp__page-size-select"
                value={itemsPerPage}
                onChange={handlePageSizeChange}
              >
                {PAGE_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="justo-cp__scroll">
            {isListLoading ? (
              <TableListSkeleton rows={10} columns={isAdmin ? 9 : 8} />
            ) : (
              <>
                <table className="table table-border-horizontal cp-listing-table">
                  <thead>
                    <tr>
                      <th scope="col" className="cp-listing__name-col">
                        {strings.cpName}
                      </th>
                      <th scope="col" className="cp-listing__date-col">
                        {strings.createdDate}
                      </th>
                      <th scope="col" className="cp-listing__code-col">
                        {strings.agentCode}
                      </th>
                      <th scope="col" className="cp-listing__metric-col">
                        {strings.visits}
                      </th>
                      <th scope="col" className="cp-listing__metric-col">
                        {strings.noOfSiteVisit}
                      </th>
                      <th scope="col" className="cp-listing__metric-col">
                        {strings.noOfClosingLead}
                      </th>
                      <th scope="col" className="cp-listing__metric-col">
                        {strings.closingPercentage}
                      </th>
                      <th scope="col" className="cp-listing__status-col">
                        {strings.status}
                      </th>
                      <th scope="col" className="cp-listing__actions-col">
                        {strings.action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getchannelPartnerList?.length > 0 ? (
                      getchannelPartnerList.map((item, index) => (
                        <tr key={item?._id || index}>
                          <td className="cp-listing__name-col">
                            {renderCpCell(
                              item?.agent_name,
                              "cp-listing__primary",
                            )}
                          </td>
                          <td className="cp-listing__date-col">
                            {renderCpCell(
                              item.createdDate
                                ? moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a",
                                  )
                                : "-",
                              "cp-listing__date",
                            )}
                          </td>
                          <td className="cp-listing__code-col">
                            {renderCpCell(
                              item.agent_code,
                              "cp-listing__body",
                            )}
                          </td>
                          <td className="cp-listing__metric-col">
                            {renderCpCell(
                              item.total_visit,
                              "cp-listing__metric",
                            )}
                          </td>
                          <td className="cp-listing__metric-col">
                            {renderCpCell(
                              item.total_site_visit,
                              "cp-listing__metric",
                            )}
                          </td>
                          <td className="cp-listing__metric-col">
                            {renderCpCell(
                              item.total_closing_lead,
                              "cp-listing__metric",
                            )}
                          </td>
                          <td className="cp-listing__metric-col">
                            {renderCpCell(
                              formatClosingPercentage(
                                item.total_closing_percentage,
                              ),
                              "cp-listing__metric",
                            )}
                          </td>
                          {isAdmin ? (
                            <td className="cp-listing__status-col switchmain">
                              <span
                                className={`justo-status-pill ${
                                  item.status
                                    ? "justo-status-pill--active"
                                    : "justo-status-pill--inactive"
                                }`}
                              >
                                <i
                                  className={`fa ${
                                    item.status
                                      ? "fa-check-circle"
                                      : "fa-exclamation-circle"
                                  }`}
                                  aria-hidden="true"
                                />
                                <span>
                                  {item.status
                                    ? strings.active
                                    : strings.inactive}
                                </span>
                              </span>
                              {item.status ? (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={true}
                                    onChange={() => {
                                      handleUserStatus({
                                        cp_id: item._id,
                                        status: 2,
                                        login_id: item?.login_id,
                                      });
                                    }}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              ) : (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={false}
                                    onChange={() => {
                                      handleUserStatus({
                                        cp_id: item._id,
                                        status: 1,
                                        login_id: item?.login_id,
                                      });
                                    }}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              )}
                            </td>
                          ) : (
                            <td className="cp-listing__status-col">
                              <span
                                className={`justo-status-pill ${
                                  item.active_status
                                    ? "justo-status-pill--active"
                                    : "justo-status-pill--inactive"
                                }`}
                              >
                                <i
                                  className={`fa ${
                                    item.active_status
                                      ? "fa-check-circle"
                                      : "fa-exclamation-circle"
                                  }`}
                                  aria-hidden="true"
                                />
                                <span>
                                  {item.active_status
                                    ? strings.active
                                    : strings.inactive}
                                </span>
                              </span>
                            </td>
                          )}
                          <td className="cp-listing__actions-col">
                            <div className="cp-listing__actions">
                              {view ? (
                                <button
                                  type="button"
                                  className="cp-listing__action-btn"
                                  title={strings.viewChannelPartner}
                                  onClick={() => {
                                    const navigateTo = isAdmin
                                      ? `/viewchannelpartner/${item._id}`
                                      : `/viewchannelpartner/${item.cp_id}`;
                                    navigatpage(navigateTo);
                                  }}
                                >
                                  <i className="fa fa-eye" aria-hidden="true" />
                                </button>
                              ) : null}
                              {edit && !isAdmin ? (
                                <button
                                  type="button"
                                  className="cp-listing__action-btn"
                                  title={strings.edit}
                                  onClick={() => {
                                    navigatpage(
                                      `/add_channel_partner?cp_id=${item.cp_id}`,
                                    );
                                  }}
                                >
                                  <i className="fa fa-pencil" aria-hidden="true" />
                                </button>
                              ) : null}
                              {edit && !isAdmin ? (
                                <>
                                  <button
                                    type="button"
                                    className="cp-listing__secondary-btn cp-listing__secondary-btn--primary"
                                    onClick={() =>
                                      handleAllocateClick(item?._id)
                                    }
                                  >
                                    {strings.allocateProperty}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleButtonClick(item)}
                                    className={`cp-listing__secondary-btn ${
                                      item?.active_status
                                        ? "cp-listing__secondary-btn--danger"
                                        : "cp-listing__secondary-btn--success"
                                    }`}
                                  >
                                    {item?.active_status
                                      ? strings.deactivate
                                      : strings.activate}
                                  </button>
                                </>
                              ) : null}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr />
                    )}
                  </tbody>
                </table>
                <TableDataNotFound data={getchannelPartnerList} />
              </>
            )}
          </div>

          <Pagination
            itemsPerPage={itemsPerPage}
            totalCount={
              isAdmin
                ? channelPartnerListSelector?.response?.total_data
                : channelPartnerListSelector?.response?.data_total
            }
            listData={getchannelPartnerList}
            onPageChange={handlePageClick}
            itemOffset={page}
            setItemOffset={setPage}
          />
        </div>
      </div>

      {isModalOpen ? (
        <div
          className="modal fade show justo-cp__modal"
          style={{ display: "block", backdropFilter: "blur(5px)" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="approveModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="approveModalLabel">
                  {strings.confirmApproval}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>{strings.confirmApproveAgent}</h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="justo-cp__btn justo-cp__btn--success"
                  type="button"
                  onClick={() => handleApprove(selectedItemId)}
                >
                  Approve
                </button>
                <button
                  className="justo-cp__btn justo-cp__btn--ghost"
                  type="button"
                  onClick={() => setModalOpen(false)}
                >
                  {strings.cancel}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {showModal ? (
        <div
          className="modal fade show d-block justo-cp__modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(15, 23, 42, 0.35)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{strings.confirmAction}</h5>
                <button type="button" className="close" onClick={handleCancel}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  {strings.confirmCpStatusChange}{" "}
                  {selectedItem?.active_status
                    ? strings.deactivate
                    : strings.activate}{" "}
                  {strings.theChannelPartner}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="justo-cp__btn justo-cp__btn--ghost"
                  onClick={handleCancel}
                >
                  {strings.cancel}
                </button>
                <button
                  type="button"
                  className="justo-cp__btn justo-cp__btn--danger"
                  onClick={handleConfirm}
                >
                  {strings.confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {modalShow ? (
        <AllocateProperty
          show={modalShow}
          cp_id={selectedCpId}
          handleClose={handleCloseModal}
        />
      ) : null}
    </div>
  );
};

export default ChannelPartner;
